import { render, staticRenderFns } from "./lrQuery2.vue?vue&type=template&id=6faa952d"
import script from "./lrQuery2.vue?vue&type=script&lang=js"
export * from "./lrQuery2.vue?vue&type=script&lang=js"
import style0 from "./lrQuery2.vue?vue&type=style&index=0&id=6faa952d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports